// This code was gifted by Anthony Messerschmidt from his personal collection of code.

import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PasswordEvaluator } from './password-evaluator';

export function passwordValidator(control: AbstractControl) : ValidationErrors {
  const retVal: ValidationErrors = PasswordEvaluator.isValid(control.value) ? null : { password: 'PasswordForm_InvalidPassword_Message' };
  return retVal;
}